import { useTranslation } from "react-i18next";
import BottomPanel from "../app/panels/BottomPanel";
import { PartnersList } from "./PartnersList";

/**
 * The partners of Juisci in a bottom sheet, for the objection screen (O1, O2),
 * which has no settings stack to push the list onto (Figma
 * O1.signup-objection.partners, 4900:14135). The sheet follows its list up to
 * the panel's 80dvh cap, then the list scrolls under the panel's bottom fog.
 */
export function PartnersSheet({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <BottomPanel
      isOpen={isOpen}
      onClose={onClose}
      backdropBlur
      displayCloseButton
    >
      {/* The title starts 16px under the close button, which sits 20px below
          the top edge of the panel. */}
      <div className="flex flex-col gap-2 px-6 pb-4 pt-11">
        <h2 className="m-0 font-dm-sans text-heading-lg font-semibold text-ds-mint-900">
          {t("Our partners")}
        </h2>
        {isOpen && <PartnersList layout="mobile" policies={null} />}
      </div>
    </BottomPanel>
  );
}
